export default function AmbassadorHowItWorks() {
  const steps = [
    { n: '1', title: 'Share your link', body: 'Post your referral URL wherever your audience is active.' },
    { n: '2', title: 'Friends join Pixeloop', body: 'Referrals are tracked automatically when they sign up through your link.' },
    { n: '3', title: 'Earn when they transact', body: 'Ambassador rewards come from real activity on Pixeloop - not from signups alone.' },
  ]

  return (
    <section className="rounded-2xl border border-white/10 bg-white/5 p-5">
      <h2 className="text-lg font-bold">How it works</h2>
      <div className="mt-4 grid gap-3 md:grid-cols-3">
        {steps.map((step) => (
          <div key={step.n} className="rounded-xl border border-white/10 bg-black/30 p-4">
            <div className="inline-flex h-7 w-7 items-center justify-center rounded-full border border-cyan-300/40 bg-cyan-500/15 text-sm font-bold text-cyan-100">{step.n}</div>
            <div className="mt-2 text-sm font-semibold">{step.title}</div>
            <div className="mt-1 text-xs text-white/70">{step.body}</div>
          </div>
        ))}
      </div>
    </section>
  )
}
